<template>
    <svg class="spinner spinner-material" :width="attrs.width ?? 24" :height="attrs.height ?? 24" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
</template>

<script lang="ts" setup>
import { useAttrs, SVGAttributes } from 'vue'
const attrs: SVGAttributes = useAttrs();
</script>